import { DeliveryAddress } from 'state/delivery';
import { core } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

import protos from 'utils/protos';

const { DeliveryServiceabilityCheckRequest } = protos;

/**
 * Actions relating to the delivery feature
 */

export function updateDeliveryAddress(
  deliveryAddress: DeliveryAddress,
  latestAutocomplete?: google.maps.places.AutocompletePrediction
): BaseTockAction {
  return {
    type: AppConstants.UPDATE_DELIVERY_ADDRESS,
    payload: { deliveryAddress, latestAutocomplete },
  };
}

export function checkServiceability(request: core.IDeliveryServiceabilityCheckRequest): ApiAction {
  return {
    TockApi: {
      postProto: `/delivery/serviceability`,
      type: AppConstants.NULL,
      request: DeliveryServiceabilityCheckRequest.fromObject(request),
    },
  };
}
